import { useMemo } from 'react';

export default function useDefinitions() {
  return useMemo(() => ({
    entityName: 'Reward',
    entityNamePlural: 'Rewards',
    entityNameModule: 'cms',
    basePath: `/cms/rewards`,
  }), [])
}
